import { makeStyles } from '@alpha/ui-lib/theme';

const useStyles = makeStyles(() => ({
  accountDetails: {
    marginTop: '16px',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#F7F7F7',
    paddingBottom: '20px',
  },
  accountDetailsLine: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '16px 20px 0px 17px',
    fontSize: '14px',
  },
  card: {
    border: '1px solid #eee',
    borderRadius: '10px',
  },
  insufficientFundsTable: {
    '& tr:last-child td:last-child': {
      color: '#b95656 !important',
      fontWeight: 600,
    },
  },
  sufficientFundsTable: {
    '& tr:last-child td:last-child': {
      color: '#51A869 !important',
      fontWeight: 600,
    },
  },
  alert: {
    padding: '20px',
    color: '#3E8CC1',
    '& .text': {
      color: '#3E8CC1 !important',
      fontWeight: 400,
      lineHeight: '16.34px !important',
    },
    '& .subText': {
      color: '#3E8CC1 !important',
    },
    marginBottom: 'unset',
  },
  insufficientFundsAlert: {
    padding: '20px',
    color: '#CF752F',
    '& .text': {
      color: '#CF752F !important',
      fontWeight: 400,
    },
    '& .subText': {
      color: '#CF752F !important',
    },
    marginBottom: 'unset',
  },
}), { name: 'FundingMethodStyles' });

export default useStyles;
